import { Environment } from '@models';
import { environment as rootEnvironment } from '../../../../environments/environment.development';

export const environment: Environment = {
  ...rootEnvironment,
  role: 'Patient',
  useMock: false,
};
